export const locales = ['de', 'en'];
export const defaultLocale = 'de';
